import { createSlice } from '@reduxjs/toolkit';

export const LoadingSlice = createSlice({
  name: 'loadingName',
  initialState: {
    value: {
      loading: false,
    },
  },
  reducers: {
    Loadingfuction: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { Loadingfuction } = LoadingSlice.actions;
export default LoadingSlice.reducer;
